import { CommonModule } from '@angular/common';
import { Component, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarGridViewComponent } from '@core/components/calendar/calendar-grid-view/calendar-grid-view.component';
import { CalendarListViewComponent } from '@core/components/calendar/calendar-list-view/calendar-list-view.component';
import { IUserStore } from '@core/interfaces/interface';
import { UserStore } from '@core/stores/user.store';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CalendarTypeEnum } from '@oranta-mis/sdk';
import { fromEvent, map, startWith } from 'rxjs';

@Component({
  selector: 'app-calendar',
  imports: [
    CalendarListViewComponent,
    CalendarGridViewComponent,
    TranslocoModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
  ],
  standalone: true,
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.scss',
})
@UntilDestroy()
export class CalendarComponent {
  public readonly CalendarTypeEnum = CalendarTypeEnum;
  public calendarContainer!: ElementRef;
  public initGridDate: Date | null = null;

  public selectedTypes: CalendarTypeEnum[] = [];
  public isGridView: boolean = true;
  private isMobile: boolean = false;

  public myForm!: FormGroup;
  public user: IUserStore | null = null;

  constructor(
    private readonly fb: FormBuilder,
    private readonly userStore: UserStore,
  ) { }

  ngOnInit() {
    this.observeBreakPoints();
    this.user = this.userStore.get();

    this.buildForm();
    this.myForm.valueChanges.pipe(untilDestroyed(this)).subscribe((v) => {
      this.getSelectedTypes();
    });
  }

  private observeBreakPoints() {
    fromEvent(window, 'resize')
      .pipe(
        startWith(null),
        map(() => window.innerWidth),
        map((width) => width < 769),
      )
      .subscribe((isMobile) => {
        this.isMobile = isMobile;
        if (this.isMobile) this.isGridView = false;
      });
  }

  private buildForm(): void {
    this.myForm = this.fb.group({
      services: [false],
      education_program: [false],
      rehabilitation_program: [false],
    });
  }

  public listNavLinkClick(date: Date) {
    if (!this.isMobile) {
      this.isGridView = true;
      this.initGridDate = date;
    }
  }

  public resetTypesFilter(): void {
    if (this.selectedTypes?.length) {
      this.myForm.reset();
      this.getSelectedTypes();
    }
  }

  public resetAllFilters(): void {
    this.resetTypesFilter();
  }

  private getSelectedTypes(): void {
    this.selectedTypes = [];
    if (this.myForm.get('services')?.value) {
      this.selectedTypes.push(CalendarTypeEnum.service);
    }
    if (this.myForm.get('education_program')?.value) {
      this.selectedTypes.push(CalendarTypeEnum.education);
    }
    if (this.myForm.get('rehabilitation_program')?.value) {
      this.selectedTypes.push(CalendarTypeEnum.reb_program);
    }
  }

  public toggleCalendarView(): void {
    this.isGridView = !this.isGridView;
  }
}
